import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/shared/components/ui/card";
import { Terminal, Bot } from "lucide-react";
import { ServiceLogTerminal } from "./ServiceLogTerminal";
import { EngineAgentsFeed } from "./EngineAgentsFeed";
import { engineLogsClient } from "../services/serviceLogsService";

// Engine tab (extensão do PBI 81485): terminal Serilog operacional por padrão,
// com toggle "Agents" que agrupa as execuções por agente — mesmo modelo das
// abas Agentic (Chats) e Gateway (Tools).

type ViewMode = "logs" | "agents";

export const EngineLogsTab = () => {
  const { t } = useTranslation();
  const [mode, setMode] = useState<ViewMode>("logs");

  const modeButton = (value: ViewMode, label: string, Icon: typeof Terminal) => (
    <button
      type="button"
      aria-pressed={mode === value}
      onClick={() => setMode(value)}
      className={`flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md transition-colors ${
        mode === value
          ? "bg-background shadow-sm font-medium"
          : "text-muted-foreground hover:text-foreground"
      }`}
    >
      <Icon className="h-4 w-4" />
      {label}
    </button>
  );

  return (
    <Card className="w-full">
      <CardContent className="pt-6 space-y-4">
        <div className="inline-flex items-center gap-1 rounded-lg bg-muted p-1">
          {modeButton("logs", t("logs.modes.logs", "Logs"), Terminal)}
          {modeButton("agents", t("logs.modes.agents", "Agents"), Bot)}
        </div>

        {mode === "logs" ? (
          <ServiceLogTerminal
            client={engineLogsClient}
            terminalTitle={t("logs.engineTerminalTitle", "Terminal de Logs do Engine")}
          />
        ) : (
          <EngineAgentsFeed />
        )}
      </CardContent>
    </Card>
  );
};
